module.exports = __webpack_public_path__ + "img/github-logo.2134fc3b.png";